var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCropsSage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4476 23.34C30.1446 16.4685 22.8126 8.65201 19.8751 9.74863C16.8539 10.8765 18.0461 20.1779 20.2276 26.2384C22.8311 33.4714 27.8124 38.1938 30.6818 38.5968C30.3227 37.45 28.5955 31.963 27.3021 28.3536C25.0313 22.0163 20.8394 12.373 20.8394 12.373C20.8394 12.373 24.881 20.2271 27.0279 25.4551C28.8918 29.994 31.3307 37.4258 31.7747 38.789C32.0381 39.3946 32.7155 40.9729 33.153 42.1799C33.5173 43.185 34.0539 45 34.0539 45L34.7589 44.6867C34.7589 44.6867 34.0169 42.3228 33.4664 40.809C33.1159 39.8455 32.5479 38.4013 32.4038 38.0361C34.6982 35.588 34.2857 28.8248 32.4476 23.34Z",
    fill: "#7EB77A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4414 9.99778C24.4414 9.99778 26.4781 0.6749 29.0241 0.00992582C30.602 -0.40222 38.9336 12.1126 39.1686 20.4165C39.4921 31.8482 35.3693 32.0494 35.3693 32.0494C35.3693 32.0494 34.8743 23.0461 32.0009 18.1447C31.7297 17.6823 31.4035 17.2042 31.0408 16.7221C30.9502 15.2427 30.814 13.3949 30.63 11.8769C30.1596 7.99726 29.3374 3.10352 29.3374 3.10352C29.3374 3.10352 29.5496 8.12708 29.8074 12.2686C29.8685 13.2499 29.9821 14.4756 30.0901 15.5402C27.6444 12.6707 24.4414 9.99778 24.4414 9.99778Z",
    fill: "#568E3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0939 24.7288C17.2748 23.8331 16.1521 22.6161 15.2775 21.7088C12.8753 19.2167 8.93225 15.5202 8.93225 15.5202C8.93225 15.5202 13.1908 18.5879 15.7083 20.8079C16.2941 21.3244 17.0292 22.0098 17.6073 22.556C16.9966 19.2733 16.5306 15.0501 16.5306 15.0501C16.5306 15.0501 14.318 13.6395 12.7313 12.8568C9.79367 11.4079 7.01593 11.7209 6.34723 12.5824C4.82695 14.541 8.54392 21.1598 12.7313 25.9389C16.0918 29.7744 23.15 34.3599 23.15 34.3599C23.15 34.3599 19.4282 29.3286 18.0939 24.7288Z",
    fill: "#27682B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCropsSage);
export default __webpack_public_path__ + "static/media/ic-crops-Sage.4eb0e043fa0a6e091df075f570140d0f.svg";
export { ForwardRef as ReactComponent };